import React from 'react'
import './style.scss'
import IcFacebook from "./../../../../assets/images/Facebook.svg";

import IcYoutube from "./../../../../assets/images/TikTok.svg";
import IcInstagram from "./../../../../assets/images/Instagram.svg";
export default function NetworkIcons() {
    return (
        <div className="footer-icons"  >
            <div>
                <a
                    rel="noopener noreferrer"
                    target="_blank"
                    href="https://www.facebook.com/santanderfondoscolectivos"
                >
                    <img alt='' src={IcFacebook} />
                </a>
            </div>
            <div>
                <a
                    href="https://www.tiktok.com/@santander_ffcc"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <img alt='' src={IcYoutube} />
                </a>
            </div>
            <div>
                <a
                    href="https://www.instagram.com/santander.fondoscolectivos"
                    rel="noopener noreferrer"
                    target="_blank"
                >
                    <img alt='' src={IcInstagram} />
                </a>
            </div>
          
 
        </div>
    )
}